<template>
    <div class="location_statte">
        <div class="last_state mt-1">
            <span :class="get_state_class"></span>
        </div>
    </div>
</template>

<script>
export default {
    name: "base_location_status",
    props: {
        cur_location: {
            type: Object,
            default: () => ({
                id: 0,
                laststate: "",
            })
        }
    },

    mounted() {
        if (parseInt(this.cur_location.id) > 0) {
            if (!this.cur_location.hasOwnProperty("laststate")) {
                this.$set(this.cur_location, 'laststate', '');  // Set it reactively
            }

            try {
                this.get_location_status();
            } catch (e) {
                console.error("ERR", e);
            }
        }
    },

    methods: {
        async get_location_status() {
            if (this.cur_location.laststate.length === 0) {
                this.$set(this.cur_location, 'laststate', 'unknown');  // Ensure reactivity

                try {
                    const {data} = await agr_api.get('/aggregators/locations/' + this.cur_location.id + "/status");
                    if (data.status === "operation_success") {
                        this.$set(this.cur_location, 'laststate', data.data);  // Set it reactively
                    }
                } catch (error) {
                    console.error("API Error:", error);
                }
            }
        }
    },

    computed: {
        get_state_class() {
            if (this.cur_location.hasOwnProperty('laststate')) {
                const state = this.cur_location.laststate;
                if (state === 'active' || state === 'online') {
                    return "status status-success";
                } else if (state === 'inactive' || state === 'offline') {
                    return 'status status-danger';
                } else {
                    return 'status status-warning';
                }
            }
            return "";
        }
    }
}
</script>

<style scoped>
.location_statte .last_state {
    position: absolute;
    top: 15px;
}
</style>
